export interface ColorInfo {
    cssName: string;
    rgb: string;
}

/**
 * Full mapping of device marketing names to visual display codes.
 * Data source: color_mapping.json
 */
export const DEVICE_COLOR_MAP: Record<string, ColorInfo> = {
    "(Frost White) Pebble White": {cssName: "aliceblue", rgb: "rgb(240,248,255)"},
    "-": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "2 - Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "4 - Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "AG Frost": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "AI Aqua": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "AMG": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Ace Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Ace Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Admiral Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Aegean Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Aero Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Aerolite Black (Mystic Black)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Aerospace Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Aether Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Agate Black": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Agate Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Agate Greeen": {cssName: "cadetblue", rgb: "rgb(95,158,160)"},
    "Agate Green": {cssName: "seagreen", rgb: "rgb(46,139,87)"},
    "Agate Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Agate Red": {cssName: "sienna", rgb: "rgb(160,82,45)"},
    "Almond": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Aloe": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Alpenglow Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Alpha": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Alpha (Black)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Alpine Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Alpine Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Alpine White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Alps Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Alps Snowy Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Alps White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Aluminium Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Amazonite": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Amber Bronze": {cssName: "goldenrod", rgb: "rgb(218,165,32)"},
    "Amber Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Amber Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Amber Red": {cssName: "orangered", rgb: "rgb(255,69,0)"},
    "Amber Sunrise": {cssName: "goldenrod", rgb: "rgb(218,165,32)"},
    "Amber Yellow": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Amber Yellow (Yellow Glow)": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Ancora Red (Rose Red)": {cssName: "crimson", rgb: "rgb(220,20,60)"},
    "Angel Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Antique Brown": {cssName: "brown", rgb: "rgb(165,42,42)"},
    "Apex Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Apricot": {cssName: "peachpuff", rgb: "rgb(255,218,185)"},
    "Apricot Crush": {cssName: "peachpuff", rgb: "rgb(255,218,185)"},
    "Aqua": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Aqua Blue": {cssName: "dodgerblue", rgb: "rgb(30,144,255)"},
    "Aqua Flow": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Aqua Foam": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Aqua Glitter": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Aqua Green": {cssName: "darkcyan", rgb: "rgb(0,139,139)"},
    "Aqua Green (Lake Green)": {cssName: "seagreen", rgb: "rgb(46,139,87)"},
    "Aqua Sky": {cssName: "turquoise", rgb: "rgb(64,224,208)"},
    "Aqua Surge": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Aquamarine": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Aquamarine Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Aquamarine Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Arctic B": {cssName: "powderblue", rgb: "rgb(176,224,230)"},
    "Arctic Blue": {cssName: "mediumslateblue", rgb: "rgb(123,104,238)"},
    "Arctic Dawn": {cssName: "powderblue", rgb: "rgb(176,224,230)"},
    "Arctic Frost": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Arctic Glow": {cssName: "powderblue", rgb: "rgb(176,224,230)"},
    "Arctic Gray": {cssName: "darkgray", rgb: "rgb(169,169,169)"},
    "Arctic Purple": {cssName: "mediumpurple", rgb: "rgb(147,112,219)"},
    "Arctic Silver": {cssName: "lightgray", rgb: "rgb(211,211,211)"},
    "Arctic Sky": {cssName: "lightblue", rgb: "rgb(173,216,230)"},
    "Arctic Slate": {cssName: "darkgray", rgb: "rgb(169,169,169)"},
    "Arctic White": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Armor Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Army Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Artic Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Artistic Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Artistic Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Ash Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Ash Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Ashleigh Blue)": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Asteroid Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Aston Martin Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Aston Martin Racing Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Astral Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Astral Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Astral Ice": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Astral Trail": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Astral White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Astro Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Astro Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Astro Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Atlantic Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Atlantic Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Atlantis Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Atmos Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Attractive Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Aura Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Aura Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Aura Glow": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Aura Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Aura Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Aura White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Aurora": {cssName: "mediumseagreen", rgb: "rgb(60,179,113)"},
    "Aurora Black": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Aurora Blue": {cssName: "steelblue", rgb: "rgb(70,130,180)"},
    "Aurora Cloud": {cssName: "mediumseagreen", rgb: "rgb(60,179,113)"},
    "Aurora Dawn": {cssName: "mediumseagreen", rgb: "rgb(60,179,113)"},
    "Aurora Glamour": {cssName: "mediumseagreen", rgb: "rgb(60,179,113)"},
    "Aurora Gold": {cssName: "yellowgreen", rgb: "rgb(154,205,50)"},
    "Aurora Gray": {cssName: "cadetblue", rgb: "rgb(95,158,160)"},
    "Aurora Green": {cssName: "seagreen", rgb: "rgb(46,139,87)"},
    "Aurora Green (Forest Green)": {cssName: "forestgreen", rgb: "rgb(34,139,34)"},
    "Aurora Green (Ocean Green)": {cssName: "seagreen", rgb: "rgb(46,139,87)"},
    "Aurora Grey": {cssName: "cadetblue", rgb: "rgb(95,158,160)"},
    "Aurora Purple": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Aurora Purple (Coral Purple)": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Aurora Red": {cssName: "sienna", rgb: "rgb(160,82,45)"},
    "Aurora Silver": {cssName: "darkseagreen", rgb: "rgb(143,188,143)"},
    "Aurora White": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Auroral Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Auspicious Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Autumn Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Awesome Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Awesome Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Awesome Mint": {cssName: "palegreen", rgb: "rgb(152,251,152)"},
    "Awesome Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Awesome Violet": {cssName: "blueviolet", rgb: "rgb(138,43,226)"},
    "Awesome White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Azure": {cssName: "dodgerblue", rgb: "rgb(30,144,255)"},
    "Azure Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Azure Glow": {cssName: "dodgerblue", rgb: "rgb(30,144,255)"},
    "Azure Sky": {cssName: "cornflowerblue", rgb: "rgb(100,149,237)"},
    "Azure Wave Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Azurite Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "BMW M Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "BMW M branding)": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Baby Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Bahama Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Bahamas Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Baltic Blue (Mist Blue)": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Baltic Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Bamboo Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Barca Fusion edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Barely Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Basalt Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Basalt Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Basalt Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Bay": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Bay Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Beach Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Beach Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Beach Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Beach Sand": {cssName: "sandybrown", rgb: "rgb(244,164,96)"},
    "Beach Sand (Pumice Stone)": {cssName: "sandybrown", rgb: "rgb(244,164,96)"},
    "Beige": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Berry Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Bespoke Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Bifrost Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Bikaner Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Birch Wood": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black & Silver with Customizable Keypad": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Black Beat": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black Beauty": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black Carbon": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black Ceramic": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black Desire": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black Diamond": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black Dusk": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black Eclipse": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black Engine": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black Glare": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black Gold": {cssName: "olive", rgb: "rgb(128,128,0)"},
    "Black Green": {cssName: "darkgreen", rgb: "rgb(0,100,0)"},
    "Black Infinity": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black Milky Way": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black Ninja": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black Ocean": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Black Onyx": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black Panther": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black Rock": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black Starlight (Midnight Black)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black Steel": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Black Titanium": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Black Twilight": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Black Velvet": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Black; other colors": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Blade Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Blade White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Blaster Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Blaze Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Blazing Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Blazing Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Blazing Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Bleen": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Bling Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Blizzard White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Bloom White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Blossom Glow": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Blue (eco leather)": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Blue Black": {cssName: "navy", rgb: "rgb(0,0,128)"},
    "Blue Borealis": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Blue Breeze": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Blue Flame": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Blue Gold": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Blue Hawaii": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Blue Haze": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Blue Hour (Vegan  Leather)": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Blue Lagoon": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Blue Lavender": {cssName: "mediumslateblue", rgb: "rgb(123,104,238)"},
    "Blue Marble": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Blue Purple": {cssName: "indigo", rgb: "rgb(75,0,130)"},
    "Blue Quantum": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Blue Shadow": {cssName: "darkblue", rgb: "rgb(0,0,139)"},
    "Blue Soda": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Blue Tide": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Blue Titanium": {cssName: "slateblue", rgb: "rgb(106,90,205)"},
    "Blue Topaz": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Blue Vegan Leather": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Blue Void": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Blue Water Emerald": {cssName: "darkcyan", rgb: "rgb(0,139,139)"},
    "Blue gradient": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Blue; other colours": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Blueberry": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Blush Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Blush Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Boba Black (Vinyl Black)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Bold Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Bolivia Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Booster Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Bora Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Brave Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Breathing Crystal": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Breeze Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Breeze Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Brick Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Bright Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Brilliant Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Brilliant Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Brilliant Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Brilliant White (Opal White)": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Brilliant White (Pearl White)": {cssName: "floralwhite", rgb: "rgb(255,250,240)"},
    "Brocade White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Bromo Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Bronze": {cssName: "peru", rgb: "rgb(205,133,63)"},
    "Brown": {cssName: "brown", rgb: "rgb(165,42,42)"},
    "Bruce Lee Yellow": {cssName: "yellow", rgb: "rgb(255,255,0)"},
    "Brushed Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Brushed Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Bubblegum Blue (Jazz Blue)": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Bumblebee Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Burano Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Burgundy": {cssName: "maroon", rgb: "rgb(128,0,0)"},
    "Burgundy Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Burnished graphite": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Burnt Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Butter Cream": {cssName: "lemonchiffon", rgb: "rgb(255,250,205)"},
    "Butterfly Feather Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Cabaret": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "California Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Camo": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Camo Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Camouflage": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Caneel Bay": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Cannon Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Capri Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Caramel": {cssName: "peru", rgb: "rgb(205,133,63)"},
    "Caramel Glow": {cssName: "peru", rgb: "rgb(205,133,63)"},
    "Caramel Latte": {cssName: "peru", rgb: "rgb(205,133,63)"},
    "Carbon Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Carbon Blue": {cssName: "darkblue", rgb: "rgb(0,0,139)"},
    "Carbon Fiber": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Carbon Gray": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Carbon Gray (Midnight Black)": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Carbon Grey": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Caribbean Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Caribbean Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Cattleya Orchid": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Cayenne grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Cedar Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Cedar White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Celadon Marble": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Celestial Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Celestial Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Celestial Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Celestial Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Celestial Snow": {cssName: "snow", rgb: "rgb(255,250,250)"},
    "Ceramic": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Ceramic Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Ceramic Black (Cosmic Black)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Ceramic Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Ceramic Flora Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Ceramic White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Ceramic White (Cosmic White)": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Cerulean Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Chalk": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Champagne": {cssName: "blanchedalmond", rgb: "rgb(255,235,205)"},
    "Champagne Gold": {cssName: "khaki", rgb: "rgb(240,230,140)"},
    "Champagne Silver": {cssName: "lightgray", rgb: "rgb(211,211,211)"},
    "Champion Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Champion Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Charcoal": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Charcoal Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Charcoal Gray": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Charcoal Grey": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Charcoal with crimson trim": {cssName: "brown", rgb: "rgb(165,42,42)"},
    "Charkoal Ink": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Charm Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Charm Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Charm Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Checkered Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Cherry Blossom": {cssName: "indianred", rgb: "rgb(205,92,92)"},
    "Cherry Pink": {cssName: "palevioletred", rgb: "rgb(219,112,147)"},
    "Chromatic Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Chromatic Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Chrome Blue": {cssName: "slateblue", rgb: "rgb(106,90,205)"},
    "Chrome Pewter": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Chrome Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Chromium White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Chrysanthemum": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Cintrine": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Citrus Yellow": {cssName: "yellow", rgb: "rgb(255,255,0)"},
    "Citrus orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Clacier Creen": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Classic Black": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Classic Blue": {cssName: "darkslateblue", rgb: "rgb(72,61,139)"},
    "Classic Silver": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Classy Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Classy Brown": {cssName: "brown", rgb: "rgb(165,42,42)"},
    "Classy White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Clearly White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Cloud Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Cloud Lavender": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Cloud Mint": {cssName: "palegreen", rgb: "rgb(152,251,152)"},
    "Cloud Navy": {cssName: "navy", rgb: "rgb(0,0,128)"},
    "Cloud Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Cloud Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Cloud Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Cloud Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Cloud White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Cloudwing Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Cloudy Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Cloudy White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Clover Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Coastal Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Coastline Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Cobalt Blue": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Cobalt Violet": {cssName: "slateblue", rgb: "rgb(106,90,205)"},
    "Coca-Cola edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Cocktail Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Coco Pearl": {cssName: "antiquewhite", rgb: "rgb(250,235,215)"},
    "Cocoa Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Cocoa Tea Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Coffee": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Coffee Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Collector Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "CollectorРІР‚в„ўs Edition Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Comet Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Comet Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Comet Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Comet Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Comet White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Concord Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Conqueror Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Conquest Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Cool Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Cool Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Cool Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Cool Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Cool Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Copper": {cssName: "peru", rgb: "rgb(205,133,63)"},
    "Coral": {cssName: "coral", rgb: "rgb(255,127,80)"},
    "Coral Gold": {cssName: "goldenrod", rgb: "rgb(218,165,32)"},
    "Coral Green": {cssName: "olivedrab", rgb: "rgb(107,142,35)"},
    "Coral Orange": {cssName: "darkorange", rgb: "rgb(255,140,0)"},
    "Coral Pink": {cssName: "lightsalmon", rgb: "rgb(255,160,122)"},
    "Coral Purple": {cssName: "indianred", rgb: "rgb(205,92,92)"},
    "Coral Red": {cssName: "orangered", rgb: "rgb(255,69,0)"},
    "Coral Tides": {cssName: "coral", rgb: "rgb(255,127,80)"},
    "Coslight Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Cosmic Aurora": {cssName: "seagreen", rgb: "rgb(46,139,87)"},
    "Cosmic Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Cosmic Blue": {cssName: "darkblue", rgb: "rgb(0,0,139)"},
    "Cosmic Emerald": {cssName: "seagreen", rgb: "rgb(46,139,87)"},
    "Cosmic Gold": {cssName: "olivedrab", rgb: "rgb(107,142,35)"},
    "Cosmic Gray": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Cosmic Green": {cssName: "darkgreen", rgb: "rgb(0,100,0)"},
    "Cosmic Grey": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Cosmic Lavender": {cssName: "lightslategray", rgb: "rgb(119,136,153)"},
    "Cosmic Mocha": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Cosmic Purple": {cssName: "indigo", rgb: "rgb(75,0,130)"},
    "Cosmic Shine": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Cosmic Sky": {cssName: "steelblue", rgb: "rgb(70,130,180)"},
    "Cosmic Titanium": {cssName: "darkslateblue", rgb: "rgb(72,61,139)"},
    "Cosmic White": {cssName: "lightslategray", rgb: "rgb(119,136,153)"},
    "Cosmo Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Cosmos Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Cosmos Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Cosy Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Country Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Cream": {cssName: "lemonchiffon", rgb: "rgb(255,250,205)"},
    "Cream Gold": {cssName: "khaki", rgb: "rgb(240,230,140)"},
    "Cream White": {cssName: "lightyellow", rgb: "rgb(255,255,224)"},
    "Creamy White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Crimson Art (Note 14 SE)": {cssName: "crimson", rgb: "rgb(220,20,60)"},
    "Crimson Bliss": {cssName: "crimson", rgb: "rgb(220,20,60)"},
    "Cross Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Cross Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Crown Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Cruise Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Crush Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Cryolite Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Crystal Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Crystal Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Crystal Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Crystal Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Crystal Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Crystal Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Crystal Symphony": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Crystal White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Crystal gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Cyan": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Cyan Green": {cssName: "darkcyan", rgb: "rgb(0,139,139)"},
    "Cyan Lake": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Cyber Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Cyber Blaze": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Cyber Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Cyber Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Cyber Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Cyber Grid": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Cyber Neon": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Cyber Rage": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Cyber Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Cyber Teal": {cssName: "teal", rgb: "rgb(0,128,128)"},
    "Cyber Titanium": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Cyber White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Cyber Yellow": {cssName: "yellow", rgb: "rgb(255,255,0)"},
    "Cyberpunk 2077 Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Cyclone": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Cyclone (Transparent Black Version)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Cyclone (Transparent Black)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Cypress Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Cyprus Teal": {cssName: "teal", rgb: "rgb(0,128,128)"},
    "Cystal Flake": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Dancing Waves": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Dark Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Dark Blue": {cssName: "darkblue", rgb: "rgb(0,0,139)"},
    "Dark Chrome": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Dark Cruise": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Dark Cyan": {cssName: "darkcyan", rgb: "rgb(0,139,139)"},
    "Dark Flare": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Dark Gray": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Dark Green": {cssName: "darkgreen", rgb: "rgb(0,100,0)"},
    "Dark Green (Majestic Green)": {cssName: "darkgreen", rgb: "rgb(0,100,0)"},
    "Dark Grey": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Dark Illusion": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Dark Knight": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Dark Matter": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Dark Matter Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Dark Night": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Dark Night Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Dark Nova": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Dark Oak Wood": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Dark Pearl": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Dark Purple": {cssName: "indigo", rgb: "rgb(75,0,130)"},
    "Dark Red": {cssName: "brown", rgb: "rgb(165,42,42)"},
    "Dark Shadow": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Dark Storm": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Dark Welkin": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Dark grey": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Dark red": {cssName: "brown", rgb: "rgb(165,42,42)"},
    "Dash Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Dash Yellow": {cssName: "yellow", rgb: "rgb(255,255,0)"},
    "Dawn Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Dawn Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Dawn Gold (Sunrise Gold)": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Dawn Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Dawn Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Dawn White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Dawnlight Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Daybreak Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Daybreak Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Daybreak Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Daylight Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Dazzle Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Dazzle Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Dazzling Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Dazzling Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Dazzling BlueРІР‚РЃ": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Dazzling Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Dazzling Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Deep Blue": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Deep Blue Sea": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Deep Fog Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Deep Forest": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Deep Gold": {cssName: "sienna", rgb: "rgb(160,82,45)"},
    "Deep Gray": {cssName: "darkslateblue", rgb: "rgb(72,61,139)"},
    "Deep Green": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Deep Grey": {cssName: "darkslateblue", rgb: "rgb(72,61,139)"},
    "Deep Indigo": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Deep Ocean": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Deep Ocean Blue": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Deep Purple": {cssName: "indigo", rgb: "rgb(75,0,130)"},
    "Deep Sapphire Blue": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Deep Sea": {cssName: "teal", rgb: "rgb(0,128,128)"},
    "Deep Sea Blue": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Deep Sea Blue (Ocean Blue)": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Deepsea Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Deepsea Luster": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Denim": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Denim Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Denim Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Desert Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Desert Sand": {cssName: "sandybrown", rgb: "rgb(244,164,96)"},
    "Desert Titanium": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Design Sleet (Black Version)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Dew White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Diamond": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Diamond Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Diamond Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Diamond Flare": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Diamond Glow": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Diamond Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Diamond Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Diamond Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Diamond White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Diamont Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Digital Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Digital Lavender": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Digital Sliver": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Digital blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Dill": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Dim Forest Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Diwali Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Dream Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Dream Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Dream Glow": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Dream White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Dreamland Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Dreamweaver (Jimmy Choo)": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Dreamy Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Dreamy Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Dreamy Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Dreamy Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Dreamy Violet": {cssName: "blueviolet", rgb: "rgb(138,43,226)"},
    "Dreamy White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Dresden Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Drifting White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Drizzling Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Dry Ice": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Dune Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Dune Titanium": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Dusk": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Dusk (Black Transparent)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Dusk (Transparent Dark Knight)": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Dusk Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Dusk Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Dusk Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Dusk Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Dynamic Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Dynamic Black (Imperial Black)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Dynamic Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Dynamic Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Dynamic Orabge": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Dynamic Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Dynamo Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Eagle Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Early Sunny Snow": {cssName: "snow", rgb: "rgb(255,250,250)"},
    "Earthy": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Ebony Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Eclipse Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Eclipse Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Eco Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Ecru White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Electric Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Electric Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Electric Graphite": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Electric Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Electric Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Electric Violet": {cssName: "blueviolet", rgb: "rgb(138,43,226)"},
    "Electric Yellow": {cssName: "yellow", rgb: "rgb(255,255,0)"},
    "Electric blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Electro Yellow": {cssName: "yellow", rgb: "rgb(255,255,0)"},
    "Elegant Beige": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Elegant Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Elegant Blue": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Elegant White": {cssName: "darkgray", rgb: "rgb(169,169,169)"},
    "Elite Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Emerald Blaze": {cssName: "limegreen", rgb: "rgb(50,205,50)"},
    "Emerald Dusk": {cssName: "limegreen", rgb: "rgb(50,205,50)"},
    "Emerald Forest": {cssName: "forestgreen", rgb: "rgb(34,139,34)"},
    "Emerald Glow Green": {cssName: "forestgreen", rgb: "rgb(34,139,34)"},
    "Emerald Green": {cssName: "forestgreen", rgb: "rgb(34,139,34)"},
    "Emerald Lake Green": {cssName: "forestgreen", rgb: "rgb(34,139,34)"},
    "Emperor Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Enchanted Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Endless Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Energy Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Engine Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Eternal Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Eternal Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Ethereal Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Executive silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Explorer Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Fairy Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Fairy Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Fairy White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Fairy pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Fancy Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Fancy White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Fantastic Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Fantasy Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Fantasy Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Fantasy Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Fantasy White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Fascinating Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Fearless Flame": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Feather Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Feather Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Fest Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Field Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Fiery Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Fiery Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Fire Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Fjord": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Flamboyant Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Flamingo Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Flare Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Flash Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Flash Yellow": {cssName: "yellow", rgb: "rgb(255,255,0)"},
    "Flashy Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Flora Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Flower Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Flowering Lilac": {cssName: "plum", rgb: "rgb(221,160,221)"},
    "Flowing Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Flowing Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Flowing Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Flowy Emerald": {cssName: "limegreen", rgb: "rgb(50,205,50)"},
    "Fluid Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Fluid Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Fluid Sliver": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Fluorite Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Fluorite Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Foggy Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Force Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Force black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Forest": {cssName: "forestgreen", rgb: "rgb(34,139,34)"},
    "Forest Black": {cssName: "darkgreen", rgb: "rgb(0,100,0)"},
    "Forest Blue": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Forest Gray": {cssName: "seagreen", rgb: "rgb(46,139,87)"},
    "Forest Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Forest Green (Olive Green)": {cssName: "forestgreen", rgb: "rgb(34,139,34)"},
    "Forest Grey": {cssName: "seagreen", rgb: "rgb(46,139,87)"},
    "Forest Viridian (Green)": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Forge Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Forrest Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Free Fire": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Free Fire Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Free Fire Limited Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Freestyle White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Fresh Lavender": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Fresh Turquoise": {cssName: "turquoise", rgb: "rgb(64,224,208)"},
    "Frost": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Frost (White Version)": {cssName: "aliceblue", rgb: "rgb(240,248,255)"},
    "Frost Blue": {cssName: "mediumslateblue", rgb: "rgb(123,104,238)"},
    "Frost Blue (Blue Breeze)": {cssName: "royalblue", rgb: "rgb(65,105,225)"},
    "Frost Crystal": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Frost Green": {cssName: "darkseagreen", rgb: "rgb(143,188,143)"},
    "Frost Grey": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Frost Silver": {cssName: "lightgray", rgb: "rgb(211,211,211)"},
    "Frost Sliver": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Frost White (Pebble White)": {cssName: "aliceblue", rgb: "rgb(240,248,255)"},
    "Frosted Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Frosted Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Frosted Blue (Sky Blue)": {cssName: "royalblue", rgb: "rgb(65,105,225)"},
    "Frosted Champagne": {cssName: "blanchedalmond", rgb: "rgb(255,235,205)"},
    "Frosted Emerald": {cssName: "limegreen", rgb: "rgb(50,205,50)"},
    "Frosted Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Frosted Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Frosted Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Frosted Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Frosted Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Frosted Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Frosted White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Frosty Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Frosty Ivory": {cssName: "ivory", rgb: "rgb(255,255,240)"},
    "Frosty White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Frozen Berry": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Frozen Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Frozen White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Fuchsia": {cssName: "fuchsia", rgb: "rgb(255,0,255)"},
    "Fushion Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Fusion Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Fusion Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Fusion Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Galactic Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Galactic Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Galactic Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Galactic Silver (Fantasy Silver)": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Galaxy Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Galaxy Blue": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Galaxy Gray": {cssName: "darkslateblue", rgb: "rgb(72,61,139)"},
    "Galaxy Grey": {cssName: "darkslateblue", rgb: "rgb(72,61,139)"},
    "Galaxy Silver": {cssName: "slategray", rgb: "rgb(112,128,144)"},
    "Galaxy White": {cssName: "lightslategray", rgb: "rgb(119,136,153)"},
    "Ganges Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Garden Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Geek Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Geek White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Geek blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Gem Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Genesis Noir": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Genshin Impact": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Ghost White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Glacial Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Glacial Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Glacial Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Glacier": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Glacier Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Glacier Glow": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Glacier Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Glacier Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Glacier White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Glacier blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Glam Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Glam White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Glamorous Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Glare Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Glass Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Glass Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Glass Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Glass Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Glass Lavender": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Glass Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Glass Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Glass Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Glass White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Glaze Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Glazed Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Glazed Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Glazed White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Gleam Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Gleaming Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Glimmer Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Glitter Aqua": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Glitter Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Glitter Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Glittery White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Glory Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Glory Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Gloss Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Glossy Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Glossy Lavender": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Glossy Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Glossy Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Glossy White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Glossy White with pink logos": {cssName: "mistyrose", rgb: "rgb(255,228,225)"},
    "Glossy silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Glowing Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Glowing Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Glowing Galaxy": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Glowing Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Glowing Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Glowing Lunar White": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Glowing Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Glowing Rainbow Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Glowing Starry Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Glowing galaxy": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Golden Black": {cssName: "olive", rgb: "rgb(128,128,0)"},
    "Golden Cypress": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Golden Glow": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Golden Hour": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Golden Hour (Vegan Leather)": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Golden Mist": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Gradation Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Gradation Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Gradation Sky Blue": {cssName: "royalblue", rgb: "rgb(65,105,225)"},
    "Gradient": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Gradient Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Gradient Bronze": {cssName: "peru", rgb: "rgb(205,133,63)"},
    "Gradient Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Gradient Greena": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Gradient Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Granite Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Granite Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Granite Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Granite black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Grape Compote": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Graphene Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Graphite": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Graphite Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Graphite Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Graphite Gray (Stealth Black)": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Graphite Gray (Urban Grey)": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Graphite Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Graphite Matte": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Graphite Mist": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Graphite black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Graphite black (Stealth Black)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "GraphiteGloss": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Grass Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Gravity Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Gravity Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Gray Coral": {cssName: "indianred", rgb: "rgb(205,92,92)"},
    "Gray Matt": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Gray Mirror": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Gray Mist": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Gray Onyx (Gray Ash)": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Gray Shadow": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Gray Shimmer": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Gray Sierra": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Gray; other colors": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Graygreen": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Green Apple": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Green Championship Edition": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Green Diamond": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Green Fantasy": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Green Silk": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Green Tea": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Green Wave": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Green Wood": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Green and Greener": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Green. Aurora": {cssName: "mediumseagreen", rgb: "rgb(60,179,113)"},
    "Greenery": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Greige": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Gren": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Grey Black": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Grey Sand": {cssName: "rosybrown", rgb: "rgb(188,143,143)"},
    "Grisaille": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Groovy Violet": {cssName: "blueviolet", rgb: "rgb(138,43,226)"},
    "Grunge Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Guava Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Gulf Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Gunmetal Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Gunmetal Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Hack Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Hacker Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Hacker Storm": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Halo Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Halo White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Harry Potter": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Harry Potter Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Harry Potter edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Hawaii Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Hawaii Lava Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Hawaiian Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Haze Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Haze Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Hazel": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Heart of Ocean": {cssName: "darkcyan", rgb: "rgb(0,139,139)"},
    "Heather Glass": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Hellfire Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Hello Kitty": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "High Glossy Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Himalayan Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Honor Code": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Horizon Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Horizon Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Horizon Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Horizon Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Horizon Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Hot Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Hot Rod Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Hurricane Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Hurricane Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Hyper Black": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Hyper Blue": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Hyper Titanium": {cssName: "steelblue", rgb: "rgb(70,130,180)"},
    "Hyperspace": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Hyperspace Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Ice": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Ice Age": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Ice Blue": {cssName: "mediumslateblue", rgb: "rgb(123,104,238)"},
    "Ice Blue (Glacier Blue)": {cssName: "royalblue", rgb: "rgb(65,105,225)"},
    "Ice Creek Blue": {cssName: "mediumslateblue", rgb: "rgb(123,104,238)"},
    "Ice Crystal Blue": {cssName: "mediumslateblue", rgb: "rgb(123,104,238)"},
    "Ice Cyan": {cssName: "aquamarine", rgb: "rgb(127,255,212)"},
    "Ice Dawn": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Ice Gray": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Ice Green": {cssName: "darkseagreen", rgb: "rgb(143,188,143)"},
    "Ice Jadeite": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Ice Jadelite": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Ice Lake Green": {cssName: "darkseagreen", rgb: "rgb(143,188,143)"},
    "Ice Lilac": {cssName: "thistle", rgb: "rgb(216,191,216)"},
    "Ice Mirror": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Ice Palace": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Ice Silver": {cssName: "lightgray", rgb: "rgb(211,211,211)"},
    "Ice White": {cssName: "aliceblue", rgb: "rgb(240,248,255)"},
    "Ice blue": {cssName: "mediumslateblue", rgb: "rgb(123,104,238)"},
    "Ice lake Blue": {cssName: "mediumslateblue", rgb: "rgb(123,104,238)"},
    "Ice-crystal Blue": {cssName: "mediumslateblue", rgb: "rgb(123,104,238)"},
    "IceSense Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "IceSense Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Iceberg Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Iceblue": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Iceland Basaltic Dark": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Iceland Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Iceland Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Iceland White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Icelandic Frost": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Icelandic frost": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Iconic Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Icy Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Icy Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Icy Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Iguana Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Illuminating Yellow": {cssName: "yellow", rgb: "rgb(255,255,0)"},
    "Illusion Sky": {cssName: "skyblue", rgb: "rgb(135,206,235)"},
    "Illusion Sunset": {cssName: "tomato", rgb: "rgb(255,99,71)"},
    "Imperial Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Impression Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Indigo": {cssName: "indigo", rgb: "rgb(75,0,130)"},
    "Indigo Black": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Indigo Blue": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Indigo blue": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Inferno Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Infinite Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Infinite Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Infinity Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Ink Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Ink Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Interstellar Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Interstellar Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Interstellar Glow": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Interstellar Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Interstellar Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Interstellar Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Iridescent (Fantasy)": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Iridescent Cloud": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Iridescent Ocean": {cssName: "darkcyan", rgb: "rgb(0,139,139)"},
    "Iridescent Pearl": {cssName: "antiquewhite", rgb: "rgb(250,235,215)"},
    "Iridescent Sky": {cssName: "skyblue", rgb: "rgb(135,206,235)"},
    "Iridescent White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Iris": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Iris Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Iris Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Iris purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Iron Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Iron Glass": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Iron Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Iron Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Ivory": {cssName: "ivory", rgb: "rgb(255,255,240)"},
    "Ivory White": {cssName: "snow", rgb: "rgb(255,250,250)"},
    "Ivy Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Jade": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Jade Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Jade Cyan": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Jade Fog": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Jade Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Jade Green (Moss Green)": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Jade White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Jade green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Jaguar Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Jaipur Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Jasper Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Jazzy Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Jazzy Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Jet Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Jewel Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Jewel Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Jewelry Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Jewelry Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Jungle Breath": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Jungle Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Jupiter Rock": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Just Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Just White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Karst Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Kevlar Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Khaki": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Khaki Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Khaki green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Kinda Coral": {cssName: "coral", rgb: "rgb(255,127,80)"},
    "Klein Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Knight Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Knight Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Koala Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Koala Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Koala Grey (Steel Wool)": {cssName: "slategray", rgb: "rgb(112,128,144)"},
    "Komodo Island": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Komodo Ocean": {cssName: "darkcyan", rgb: "rgb(0,139,139)"},
    "Kyanite Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Lagoon Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Lagoon Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Lake Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Lake Cyan": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Lake Glide": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Lake Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Lamborghini Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Lamborgini Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Lamborgini Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Lamborgini Yellow": {cssName: "yellow", rgb: "rgb(255,255,0)"},
    "Laser Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Laser Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Laser Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Laser Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Laser White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Latte": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Lava Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Lava Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Lavender": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Lavender Fantasy": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Lavender Frost": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Lavender Glow": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Lavender Purple": {cssName: "mediumorchid", rgb: "rgb(186,85,211)"},
    "Le Mans Blue (Nitro Blue)": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Leaf Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "League of Legends": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Leather Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Leather Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Leather Brown": {cssName: "brown", rgb: "rgb(165,42,42)"},
    "Leather Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Leather Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Leather Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Leather Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Legend": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Legend (BMW M branding)": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Legend (White w": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Legend White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Legendary Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Legendary White (BMW M branding)": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Legion Sky": {cssName: "skyblue", rgb: "rgb(135,206,235)"},
    "Lemon": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Lemon Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Lemongrass": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Light Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Light Brown": {cssName: "brown", rgb: "rgb(165,42,42)"},
    "Light Charcoal": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Light Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Light Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Light Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Light Mint": {cssName: "palegreen", rgb: "rgb(152,251,152)"},
    "Light Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Light Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Light Sea Green": {cssName: "seagreen", rgb: "rgb(46,139,87)"},
    "Light Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Light Speed Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Light blue; others": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Light-rider White (Neon Edition)": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Lightening Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Lightest Sky": {cssName: "skyblue", rgb: "rgb(135,206,235)"},
    "Lightgray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Lightning Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Lightning Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Lightning Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Lightning Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Lightning Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Lightsaber Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Lightspeed": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Lightweave Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Lilac": {cssName: "plum", rgb: "rgb(221,160,221)"},
    "Lilac Purple": {cssName: "darkorchid", rgb: "rgb(153,50,204)"},
    "Lily White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Lily White (White Swan)": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Lime": {cssName: "lime", rgb: "rgb(0,255,0)"},
    "Lime Gold": {cssName: "lawngreen", rgb: "rgb(124,252,0)"},
    "Lime Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Liquid Mercury": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Liquid Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Liquid aura": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Lit Violet": {cssName: "blueviolet", rgb: "rgb(138,43,226)"},
    "Lite Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Lite Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Lite Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Lively Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Lively Lavender": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Lotus Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Lucent White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Lucky Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Lumina Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Luminous Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Luminous Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Luna Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Lunar Black": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Lunar Blue": {cssName: "mediumslateblue", rgb: "rgb(123,104,238)"},
    "Lunar Dust": {cssName: "lightgray", rgb: "rgb(211,211,211)"},
    "Lunar Frost": {cssName: "gainsboro", rgb: "rgb(220,220,220)"},
    "Lunar Gray": {cssName: "darkgray", rgb: "rgb(169,169,169)"},
    "Lunar Grey": {cssName: "darkgray", rgb: "rgb(169,169,169)"},
    "Lunar Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Lunar White": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Lunar shadow Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Lurex Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Lush Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Lustrous Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Lustrous Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Luxe Grey (Black Luxe)": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Luxe Lavender": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Luxe Marble": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Luxe Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Luxe Violet": {cssName: "blueviolet", rgb: "rgb(138,43,226)"},
    "Luxurious Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "MInt Green": {cssName: "limegreen", rgb: "rgb(50,205,50)"},
    "Magenta": {cssName: "fuchsia", rgb: "rgb(255,0,255)"},
    "Magic Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Magic Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Magic Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Magic Night Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Magic Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Magic Skin": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Magic Skin 2.0 (Blue)": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Magic Skin 2.0 Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Magic Skin 3.0": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Magical Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Magnet Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Majestic Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Majestic Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Majestic Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Majestic Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Majestic Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Majestic Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Malachite Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Maldives Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Malibu Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Mambo Mint": {cssName: "palegreen", rgb: "rgb(152,251,152)"},
    "Mandarin Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Manish Malhotra": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Marble": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Marble Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Marble Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Marble Mist": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Marble Sands": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Marble White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Mariana Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Marigold": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Marine": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Marine Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Marrs Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Mars Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mars Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Mars Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Marshmallow Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Martian Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Martian Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Matcha Green": {cssName: "forestgreen", rgb: "rgb(34,139,34)"},
    "Matrix Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Matt Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Matte Aqua": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Matte Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Matte Brown": {cssName: "brown", rgb: "rgb(165,42,42)"},
    "Matte Charcoal": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Matte Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Matte Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Matte Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Matte Midnight Green": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Matte Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Matte Space Gray": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Mauve Mist": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mauve Sensation": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "McLaren Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Meadow Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Meadow Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Mecha Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Mecha Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Mecha Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Mecha Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Mega Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Mercedes AMG": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mercurial Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Mercury": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mercury Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mercury Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Metal Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Metal Bronze": {cssName: "peru", rgb: "rgb(205,133,63)"},
    "Metal Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Metallic Black": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Metallic Blue": {cssName: "slateblue", rgb: "rgb(106,90,205)"},
    "Metallic Grey": {cssName: "lightslategray", rgb: "rgb(119,136,153)"},
    "Metallic Purple": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Metallic Rose": {cssName: "tan", rgb: "rgb(210,180,140)"},
    "Metallic Sage": {cssName: "darkseagreen", rgb: "rgb(143,188,143)"},
    "Metallic Sand": {cssName: "tan", rgb: "rgb(210,180,140)"},
    "Metallic White": {cssName: "lightgray", rgb: "rgb(211,211,211)"},
    "Metaverse Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Metaverse Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Meteor Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Meteor Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Meteor Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Meteor Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Meteor Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Meteor Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Meteor Titanium": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Meteorite Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Meteorite Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Meteorite Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Midday Dream": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Midnight": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Midnight Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Midnight Black (Fushion Black)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Midnight Black (Glory Black)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Midnight Blue": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Midnight Blue (Navy Blazer)": {cssName: "darkblue", rgb: "rgb(0,0,139)"},
    "Midnight Frost": {cssName: "lightslategray", rgb: "rgb(119,136,153)"},
    "Midnight Galaxy": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Midnight Gray": {cssName: "darkslateblue", rgb: "rgb(72,61,139)"},
    "Midnight Green": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Midnight Grey": {cssName: "darkslateblue", rgb: "rgb(72,61,139)"},
    "Midnight Ice": {cssName: "lightslategray", rgb: "rgb(119,136,153)"},
    "Midnight Ivy": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Midnight Jade": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Midnight Jazz": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Midnight Lily": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Midnight Lily (Forest Owl)": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Midnight Magenta": {cssName: "darkviolet", rgb: "rgb(148,0,211)"},
    "Midnight Maverick": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Midnight Mist": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Midnight Ocean": {cssName: "teal", rgb: "rgb(0,128,128)"},
    "Midnight Purple": {cssName: "indigo", rgb: "rgb(75,0,130)"},
    "Midnight Shadow": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Midnight Space": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Midnight Sun": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Midnight Violet": {cssName: "rebeccapurple", rgb: "rgb(102,51,153)"},
    "Midnight blue": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Midsummer Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Mighty Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Milk": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Milky Way": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Milky Way Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Milky Way Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mineral Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Mineral Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Mineral Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mineral Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mineral White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Mineral gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mint": {cssName: "palegreen", rgb: "rgb(152,251,152)"},
    "Mint Blue": {cssName: "steelblue", rgb: "rgb(70,130,180)"},
    "Mint Cream": {cssName: "palegoldenrod", rgb: "rgb(238,232,170)"},
    "Mint Green": {cssName: "limegreen", rgb: "rgb(50,205,50)"},
    "Mint green": {cssName: "limegreen", rgb: "rgb(50,205,50)"},
    "Miracle Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Mirage Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Mirage Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Mirage Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Mirror Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Mirror Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Mirror Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Mirror Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mirror Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mirror Lake Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Mirror Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Mirror Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Mist Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Mist Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Mist Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mist Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mist Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Mist White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Misty Aqua": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Misty Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Misty Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Misty Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Misty Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Misty Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Misty Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Misty Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Misty Violet": {cssName: "blueviolet", rgb: "rgb(138,43,226)"},
    "Misty White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Mithril Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mithril Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mocha Brown": {cssName: "brown", rgb: "rgb(165,42,42)"},
    "Mocha Brown (Chocolate Mocha)": {cssName: "brown", rgb: "rgb(165,42,42)"},
    "Mocha Brown (Mocha Chocolate)": {cssName: "brown", rgb: "rgb(165,42,42)"},
    "Mocha Mousse": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Moco Cyber Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Mondrian": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Monet Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Monet Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Monet Summer": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Monsoon Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Monster Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Moon": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Moon Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Moon Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Moon Rock Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Moon Shadow": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Moon Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Moon Titanium": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Moon silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "MoonKnight Titanium": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Moondust Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Moondust Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Moonlight (Silver Transparent)": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Moonlight (Transparent Silver Deuterium)": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Moonlight Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Moonlight Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Moonlight Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Moonlight Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Moonlight Jade": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Moonlight Pearl": {cssName: "antiquewhite", rgb: "rgb(250,235,215)"},
    "Moonlight Shadow": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Moonlight Shadow (Midnight Blue)": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Moonlight Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Moonlight Sonata": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Moonlight Titanium": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Moonlight White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Moonlight White (Fushion White)": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Moonlight White (Starry White)": {cssName: "darkgray", rgb: "rgb(169,169,169)"},
    "Moonlit Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Moonlit Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Moonlit Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Moonlit Violet": {cssName: "blueviolet", rgb: "rgb(138,43,226)"},
    "Moonlit White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Moonshadow Gray; Glacier Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Moonshine Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Moonstone": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Moonstone Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Moonstone Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Moonstone White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Morandi Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Morning Mist": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Morpheus Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Moss Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Mostly Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Mountain Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Mountain Shade": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mountain Trail": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Moving Titanium": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Murky Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Muse Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Mykonos Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Mysterious Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Mysterious Black (Phantom Black)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Mystery Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Mystery Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Mystery White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Mystic Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Mystic Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Mystic Bronze": {cssName: "peru", rgb: "rgb(205,133,63)"},
    "Mystic Dawn": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mystic Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mystic Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Mystic Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Mystic Lilac": {cssName: "plum", rgb: "rgb(221,160,221)"},
    "Mystic Night": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Mystic Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Mystic Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Mystic Space": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Mystic White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Mystic indigo": {cssName: "indigo", rgb: "rgb(75,0,130)"},
    "Mystique Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Mystique White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Nano Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Nardo Gray (Silver)": {cssName: "darkgray", rgb: "rgb(169,169,169)"},
    "Naruto edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Natural": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Natural Green (Aurora Green)": {cssName: "forestgreen", rgb: "rgb(34,139,34)"},
    "Natural Titanium": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Nature Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Nautical Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Navigator Beige": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Navy": {cssName: "navy", rgb: "rgb(0,0,128)"},
    "Navy Black": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Navy Blue": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Navy Green": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Nebula": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Nebula Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Nebula Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Nebula Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Nebula Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Nebula Noir": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Nebula Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Nebula Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Nebula Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Nebula Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Nebula Violet": {cssName: "blueviolet", rgb: "rgb(138,43,226)"},
    "Nebula orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Neo Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Neo Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Neo Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Neo Mint": {cssName: "palegreen", rgb: "rgb(152,251,152)"},
    "Neo Titanium": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Neon": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Neon Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Neon Cyan": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Neon Dream": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Neon Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Neon Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Neon Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Neon Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Neon purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Neptune Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Neptune Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Nexus Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Night": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Night Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Night Blue (Anthracite Blue)": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Night Sea": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Night black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Nightfall (Matt Black)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Nightfall Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Nightsky Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Nighttime Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Nimbus Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Nitro Blaze": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Noble Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Noble Brown": {cssName: "brown", rgb: "rgb(165,42,42)"},
    "Noir": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Nordic Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Nordic Secret": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Nordic Wood": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Nordic blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "North Star Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Norway Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Nuit Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Oak": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Oasis Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Obsidian": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Obsidian Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Obsidian Edge": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Obsidian Midnight": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Ocean": {cssName: "darkcyan", rgb: "rgb(0,139,139)"},
    "Ocean Blue": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Ocean Cyan": {cssName: "darkturquoise", rgb: "rgb(0,206,209)"},
    "Ocean Green": {cssName: "teal", rgb: "rgb(0,128,128)"},
    "Ocean Green (Nature Green)": {cssName: "forestgreen", rgb: "rgb(34,139,34)"},
    "Ocean Grey": {cssName: "steelblue", rgb: "rgb(70,130,180)"},
    "Ocean Sunset": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Ocean Teal": {cssName: "darkcyan", rgb: "rgb(0,139,139)"},
    "Ocean Wave": {cssName: "darkcyan", rgb: "rgb(0,139,139)"},
    "Oceanic Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Oh So Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Olive": {cssName: "olive", rgb: "rgb(128,128,0)"},
    "Olive Black": {cssName: "darkolivegreen", rgb: "rgb(85,107,47)"},
    "Olive Green": {cssName: "forestgreen", rgb: "rgb(34,139,34)"},
    "Olive Green (Moss Green)": {cssName: "forestgreen", rgb: "rgb(34,139,34)"},
    "Olive Twilight": {cssName: "darkolivegreen", rgb: "rgb(85,107,47)"},
    "Olivine": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Onyx": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Onyx Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Onyx Black (Midnight Black)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Onyx Gray": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Onyx Green": {cssName: "darkgreen", rgb: "rgb(0,100,0)"},
    "Opal": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Opal Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Opal Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Opal White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Opal purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Opalescent": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Optimistic Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Optimus Prime Edition": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Orange Championship Edition": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Orange Copper": {cssName: "goldenrod", rgb: "rgb(218,165,32)"},
    "Orange Flare": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Orange Haze": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Orange Magma": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Orange Rose Valley": {cssName: "sandybrown", rgb: "rgb(244,164,96)"},
    "Orange Shimmer": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Orbit Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Orbit White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Orchid Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Orchid Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Orchid Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Origin Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Orion Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Orion Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Out Of The Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Oxford Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Oxygen Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Oxygen Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Pac-Man Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Pacific Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Pacific Night": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Pacific Pearl": {cssName: "antiquewhite", rgb: "rgb(250,235,215)"},
    "Pacific Sunrise": {cssName: "sandybrown", rgb: "rgb(244,164,96)"},
    "Pale Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Pale Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Pale Lilac": {cssName: "plum", rgb: "rgb(221,160,221)"},
    "Pale Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Palm Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Palm Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Palm gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Panda White (Extreme Edition)": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Pantone (Greener Pastures": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Pantone: Black Oyster": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Pantone: Bronze Green": {cssName: "olivedrab", rgb: "rgb(107,142,35)"},
    "Pantone: Gibraltar Sea": {cssName: "lightseagreen", rgb: "rgb(32,178,170)"},
    "Pantone: Gibraltar sea": {cssName: "lightseagreen", rgb: "rgb(32,178,170)"},
    "Pantone: Mocha Mousse": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Pantone: Rio Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Pantone: Shadow": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Pantone: Slipstream": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Pantone: Spellbound": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Papaya Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Paper Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Paper White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Parfait Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Paris Hilton Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Parrot Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Parrot Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Particle Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Pastel Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Pastel Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Pastel Lime": {cssName: "lime", rgb: "rgb(0,255,0)"},
    "Pastel Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Pastel Sky": {cssName: "skyblue", rgb: "rgb(135,206,235)"},
    "Pastel White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Peaceful Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Peach": {cssName: "peachpuff", rgb: "rgb(255,218,185)"},
    "Peach Fuzz": {cssName: "peachpuff", rgb: "rgb(255,218,185)"},
    "Peach Gold": {cssName: "khaki", rgb: "rgb(240,230,140)"},
    "Peach Mist": {cssName: "peachpuff", rgb: "rgb(255,218,185)"},
    "Peach Pink": {cssName: "peachpuff", rgb: "rgb(255,218,185)"},
    "Peach Pink (Tuscany Coral)": {cssName: "lightpink", rgb: "rgb(255,182,193)"},
    "Peach essence": {cssName: "peachpuff", rgb: "rgb(255,218,185)"},
    "Peacock Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Peacock Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Pearl": {cssName: "antiquewhite", rgb: "rgb(250,235,215)"},
    "Pearl Blue": {cssName: "mediumslateblue", rgb: "rgb(123,104,238)"},
    "Pearl Gold": {cssName: "khaki", rgb: "rgb(240,230,140)"},
    "Pearl Gray": {cssName: "darkgray", rgb: "rgb(169,169,169)"},
    "Pearl Sakura": {cssName: "antiquewhite", rgb: "rgb(250,235,215)"},
    "Pearl Silver": {cssName: "lightgray", rgb: "rgb(211,211,211)"},
    "Pearl White": {cssName: "linen", rgb: "rgb(250,240,230)"},
    "Pearly White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Pebble White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Peony": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Pepper Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Peppermint Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Peppy Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Peridot Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Personality Yellow": {cssName: "yellow", rgb: "rgb(255,255,0)"},
    "Petrol Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Pewter Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Phantom Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Phantom Black (Dark Pearl)": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Phantom Blue": {cssName: "darkblue", rgb: "rgb(0,0,139)"},
    "Phantom Brown": {cssName: "saddlebrown", rgb: "rgb(139,69,19)"},
    "Phantom Dusk": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Phantom Gold": {cssName: "olive", rgb: "rgb(128,128,0)"},
    "Phantom Gray": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Phantom Green": {cssName: "darkgreen", rgb: "rgb(0,100,0)"},
    "Phantom Grey": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Phantom Navy": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Phantom Pink": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Phantom Purple": {cssName: "indigo", rgb: "rgb(75,0,130)"},
    "Phantom Red": {cssName: "darkred", rgb: "rgb(139,0,0)"},
    "Phantom Silver": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Phantom Titanium": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Phantom Violet": {cssName: "darkslateblue", rgb: "rgb(72,61,139)"},
    "Phantom White": {cssName: "lightslategray", rgb: "rgb(119,136,153)"},
    "Phantom crystal": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Phoenix Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Phoenix Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Phoenix Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Photographer Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Piano Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Pilot Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Pine Green": {cssName: "forestgreen", rgb: "rgb(34,139,34)"},
    "Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Pink Clay": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Pink Gold": {cssName: "sandybrown", rgb: "rgb(244,164,96)"},
    "Pink Lavender": {cssName: "mistyrose", rgb: "rgb(255,228,225)"},
    "Pink Satin": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Pink Vibe": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Pink and Lime": {cssName: "lightgreen", rgb: "rgb(144,238,144)"},
    "Pink gradient": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Pioneer Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Pitch Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Pitch Black (Greyish Black)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Placid Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Plain Black (Asphalt Black)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Platinum": {cssName: "gainsboro", rgb: "rgb(220,220,220)"},
    "Platinum Black": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Platinum Gray": {cssName: "darkgray", rgb: "rgb(169,169,169)"},
    "Platinum Silver": {cssName: "lightgray", rgb: "rgb(211,211,211)"},
    "Platinum silver": {cssName: "lightgray", rgb: "rgb(211,211,211)"},
    "Playful Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Plum": {cssName: "plum", rgb: "rgb(221,160,221)"},
    "Plum Red": {cssName: "indianred", rgb: "rgb(205,92,92)"},
    "Plum perfect": {cssName: "plum", rgb: "rgb(221,160,221)"},
    "Plume Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Plume White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Poco Yellow": {cssName: "yellow", rgb: "rgb(255,255,0)"},
    "Poinciana": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Polar": {cssName: "ghostwhite", rgb: "rgb(248,248,255)"},
    "Polar Black": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Polar Blue": {cssName: "mediumslateblue", rgb: "rgb(123,104,238)"},
    "Polar Night": {cssName: "lightslategray", rgb: "rgb(119,136,153)"},
    "Polar Night Black": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Polar Silver": {cssName: "gainsboro", rgb: "rgb(220,220,220)"},
    "Polar White": {cssName: "ghostwhite", rgb: "rgb(248,248,255)"},
    "Polar White (Phantom White)": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Polar night": {cssName: "lightslategray", rgb: "rgb(119,136,153)"},
    "Polished Graphite": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Pop Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Porcelain": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Porcelain White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Powder Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Powehi": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Power Black": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Power Blue": {cssName: "darkslateblue", rgb: "rgb(72,61,139)"},
    "Power Gray": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Power Grey": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Power Pink": {cssName: "rosybrown", rgb: "rgb(188,143,143)"},
    "Power Silver": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Predator Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Predawn Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Premium Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Premium Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Prestige Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Pretty Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Prime Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Prime Blue": {cssName: "darkblue", rgb: "rgb(0,0,139)"},
    "Prism Black": {cssName: "darkslateblue", rgb: "rgb(72,61,139)"},
    "Prism Blue": {cssName: "slateblue", rgb: "rgb(106,90,205)"},
    "Prism Bricks Black": {cssName: "darkslateblue", rgb: "rgb(72,61,139)"},
    "Prism Bricks Blue": {cssName: "slateblue", rgb: "rgb(106,90,205)"},
    "Prism Crush Black": {cssName: "darkslateblue", rgb: "rgb(72,61,139)"},
    "Prism Crush Blue": {cssName: "slateblue", rgb: "rgb(106,90,205)"},
    "Prism Crush Green": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Prism Crush Pink": {cssName: "plum", rgb: "rgb(221,160,221)"},
    "Prism Crush Red": {cssName: "indianred", rgb: "rgb(205,92,92)"},
    "Prism Crush Silver": {cssName: "darkgray", rgb: "rgb(169,169,169)"},
    "Prism Crush Violet2": {cssName: "mediumorchid", rgb: "rgb(186,85,211)"},
    "Prism Crush White": {cssName: "thistle", rgb: "rgb(216,191,216)"},
    "Prism Cube Black": {cssName: "darkslateblue", rgb: "rgb(72,61,139)"},
    "Prism Cube Blue": {cssName: "slateblue", rgb: "rgb(106,90,205)"},
    "Prism Cube Pink": {cssName: "plum", rgb: "rgb(221,160,221)"},
    "Prism Cube Sliver": {cssName: "mediumorchid", rgb: "rgb(186,85,211)"},
    "Prism Cube White": {cssName: "thistle", rgb: "rgb(216,191,216)"},
    "Prism Dot Black": {cssName: "darkslateblue", rgb: "rgb(72,61,139)"},
    "Prism Dot Gray": {cssName: "lightslategray", rgb: "rgb(119,136,153)"},
    "Prism Dot White": {cssName: "thistle", rgb: "rgb(216,191,216)"},
    "Prism Gold": {cssName: "darksalmon", rgb: "rgb(233,150,122)"},
    "Prism Magic": {cssName: "mediumorchid", rgb: "rgb(186,85,211)"},
    "Prism Silver": {cssName: "darkgray", rgb: "rgb(169,169,169)"},
    "Prism White": {cssName: "thistle", rgb: "rgb(216,191,216)"},
    "Pristine Glass": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Pronto Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Provence": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Provence Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Pulsar": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Pulse": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Pulse Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Pulse White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Punk Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Pure Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Pure Flame": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Pure Titanium": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Pure White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Purist Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Purple Blossom": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Purple Dawn": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Purple Fairy": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Purple Haze": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Purple Mist": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Purple Nebula": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Purple Orchid": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Purple Phantom": {cssName: "indigo", rgb: "rgb(75,0,130)"},
    "Purple Twilight": {cssName: "rebeccapurple", rgb: "rgb(102,51,153)"},
    "Purple-ish": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Quantum Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Quantum Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Quartz Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Quartz Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Quetzal Cyan": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Quick Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Rabit red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Racing Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Racing Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Racing Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Racing Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Racing Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Racing Yellow": {cssName: "yellow", rgb: "rgb(255,255,0)"},
    "Radiant Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Radiant Pearl": {cssName: "antiquewhite", rgb: "rgb(250,235,215)"},
    "Radiant Starstream": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Raging Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Rainbow": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Rainbow Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Rainbow Fantasy": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Rainbow Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Rainbow Spectrum": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Rainforest": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Rainy Night": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Raspberry Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Raven Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Razor Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Rebel Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Red (Iron Man Edition)": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Red (New Year Edition)": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Red Terracotta": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Reddish Brown": {cssName: "brown", rgb: "rgb(165,42,42)"},
    "Reef Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Rhombic Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Ribbons White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Ripple Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Ripple Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Rippling Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Rising Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "River Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Rock Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Rock Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Rocking Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Rococo Pearl": {cssName: "antiquewhite", rgb: "rgb(250,235,215)"},
    "Roland Violet": {cssName: "blueviolet", rgb: "rgb(138,43,226)"},
    "Roman Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Rome Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Rose": {cssName: "lightsalmon", rgb: "rgb(255,160,122)"},
    "Rose Champagne": {cssName: "lightpink", rgb: "rgb(255,182,193)"},
    "Rose Gold": {cssName: "sandybrown", rgb: "rgb(244,164,96)"},
    "Rose Gold Beach": {cssName: "sandybrown", rgb: "rgb(244,164,96)"},
    "Rose Quartz": {cssName: "lightsalmon", rgb: "rgb(255,160,122)"},
    "Rose pink": {cssName: "lightpink", rgb: "rgb(255,182,193)"},
    "Rosy Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Royal Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Royal Bronze": {cssName: "peru", rgb: "rgb(205,133,63)"},
    "Royal Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Royal Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Royal Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Ruby Red": {cssName: "firebrick", rgb: "rgb(178,34,34)"},
    "Rust Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Rusted brown": {cssName: "brown", rgb: "rgb(165,42,42)"},
    "Safari Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Saffron Delight": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Sage": {cssName: "darkseagreen", rgb: "rgb(143,188,143)"},
    "Sage Green": {cssName: "seagreen", rgb: "rgb(46,139,87)"},
    "Sahara Gleam": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Sahara Sand Brown": {cssName: "indianred", rgb: "rgb(205,92,92)"},
    "Sailing Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Sakura Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Sakura White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Sand": {cssName: "sandybrown", rgb: "rgb(244,164,96)"},
    "Sand Black": {cssName: "saddlebrown", rgb: "rgb(139,69,19)"},
    "Sand Dune": {cssName: "sandybrown", rgb: "rgb(244,164,96)"},
    "Sand Gold": {cssName: "goldenrod", rgb: "rgb(218,165,32)"},
    "Sand Green": {cssName: "olivedrab", rgb: "rgb(107,142,35)"},
    "Sand gold": {cssName: "goldenrod", rgb: "rgb(218,165,32)"},
    "Sandstone": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Sandstone Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Sandstone Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Sandstone Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Sandy Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Sandy Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "SandР’В Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Sapphire Black": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Sapphire Blue": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Sapphire Blue (Jewel Blue)": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Satin Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Satin Black (Titanium Grey)": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Satin Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Satin Coral": {cssName: "coral", rgb: "rgb(255,127,80)"},
    "Satin Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Satin Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Satin Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Scar red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Scarab": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Scarlet Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Scarlet Wave": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Science Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Scorching Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Scuba Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Sea": {cssName: "lightseagreen", rgb: "rgb(32,178,170)"},
    "Sea Blue": {cssName: "royalblue", rgb: "rgb(65,105,225)"},
    "Sea Breeze Green": {cssName: "seagreen", rgb: "rgb(46,139,87)"},
    "Sea Glass Green": {cssName: "seagreen", rgb: "rgb(46,139,87)"},
    "Sea Green": {cssName: "seagreen", rgb: "rgb(46,139,87)"},
    "Sea Salt White": {cssName: "skyblue", rgb: "rgb(135,206,235)"},
    "Seabed Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Seafoam Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Seagull Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Seashell White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Seashore Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Seawater Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Serene Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Serenity Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Shade Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Shadow (Dark Knight)": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Shadow Ash": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Shadow Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Shadow Black (Onyx Gray)": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Shadow Blue": {cssName: "darkblue", rgb: "rgb(0,0,139)"},
    "Shadow Gray": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "ShadowР’В Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Shamrock": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Shell Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Shim Silver Green": {cssName: "mediumseagreen", rgb: "rgb(60,179,113)"},
    "Shimmer Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Shimmer Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Shimmer Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Shining Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Shiny Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Shiny Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Shiny Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Shoal Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Sierra Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Sierra Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Silk Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Silk Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Silk Blue (Feather Blue)": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Silk Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Silk Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Silk Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Silk Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Silk black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Silk green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Silky Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Silky Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Silky White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Silver (Glacial White)": {cssName: "gainsboro", rgb: "rgb(220,220,220)"},
    "Silver Chrome": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Silver Diamond": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Silver Fantasy": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Silver Frost": {cssName: "lightgray", rgb: "rgb(211,211,211)"},
    "Silver Knight": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Silver Moon": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Silver Ray": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Silver Shadow": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Silver Soul": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Silver Wave": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Silver black": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Silver-Fuchsia": {cssName: "orchid", rgb: "rgb(218,112,214)"},
    "Silver-Gray": {cssName: "darkgray", rgb: "rgb(169,169,169)"},
    "SilverShine": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Silverstone White (Sprint White)": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Silvery Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Silvery White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Skin Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Sky": {cssName: "skyblue", rgb: "rgb(135,206,235)"},
    "Sky Black": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Sky Blue": {cssName: "royalblue", rgb: "rgb(65,105,225)"},
    "Sky Blue (Ocean Blue)": {cssName: "royalblue", rgb: "rgb(65,105,225)"},
    "Sky Blue (Sea Blue)": {cssName: "royalblue", rgb: "rgb(65,105,225)"},
    "Sky Cloud Black": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Sky Cyan": {cssName: "turquoise", rgb: "rgb(64,224,208)"},
    "Sky Mirror": {cssName: "skyblue", rgb: "rgb(135,206,235)"},
    "Sky Purple": {cssName: "slateblue", rgb: "rgb(106,90,205)"},
    "Sky White": {cssName: "paleturquoise", rgb: "rgb(175,238,238)"},
    "Sky blue": {cssName: "royalblue", rgb: "rgb(65,105,225)"},
    "Skylight Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Skyline Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Skyline Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Skyline Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Skyline White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Slate": {cssName: "slategray", rgb: "rgb(112,128,144)"},
    "Slate Black": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Slate Blue": {cssName: "royalblue", rgb: "rgb(65,105,225)"},
    "Slate Blue (Mostly Blue)": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Slate Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Slate Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Sleek Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Sleek Black Titanium Silver": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Sleek Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Sleet (Black)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Smoke Black": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Smokey Sangria": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Smoky Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Smoky Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Snow": {cssName: "snow", rgb: "rgb(255,250,250)"},
    "Snow White": {cssName: "snow", rgb: "rgb(255,250,250)"},
    "Snowfall": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Snowfall (Silver Version)": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Snowfall (Silver)": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Snowflake White (Diamond Dazzle)": {cssName: "white", rgb: "rgb(255,255,255)"},
    "So Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "So Peach": {cssName: "peachpuff", rgb: "rgb(255,218,185)"},
    "So White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Soft pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Solar Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Solar Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Solar Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Solid Ice": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Solstice Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Sonic Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Sonic White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Sonic Yellow": {cssName: "yellow", rgb: "rgb(255,255,0)"},
    "Soothing Sea": {cssName: "lightseagreen", rgb: "rgb(32,178,170)"},
    "Sorta Sage": {cssName: "darkseagreen", rgb: "rgb(143,188,143)"},
    "Sorta Seafoam": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Sorta Sunny": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Soul Eye Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Soulful Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Space Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Space Blue": {cssName: "darkblue", rgb: "rgb(0,0,139)"},
    "Space Brown": {cssName: "saddlebrown", rgb: "rgb(139,69,19)"},
    "Space Dark": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Space Fusion": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Space Gray": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Space Grey": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Space Purple": {cssName: "indigo", rgb: "rgb(75,0,130)"},
    "Space Silver": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Space Titanium": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Space blue": {cssName: "darkblue", rgb: "rgb(0,0,139)"},
    "Spark Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Sparkle Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Sparkle Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Sparkle Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Sparkling Grape": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Sparkling Ivory": {cssName: "ivory", rgb: "rgb(255,255,240)"},
    "Special Edition Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Speckled Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Spectre Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Speed Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Speed Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Speed Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Speed Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Speed Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Splendid Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Sport Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Sport Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Sporty Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Spring Bud": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Spring Bud Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Spring Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Spring Green (Dill)": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Spring Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Sprint Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Spritz Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Spritz Orange (Arabesque)": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Spruce Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Star Ash": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Star Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Star Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Star Blue (Lake Blue)": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Star Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Star Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Star Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Star White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Star Wish Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Stardust Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Stardust Brown": {cssName: "brown", rgb: "rgb(165,42,42)"},
    "Stardust Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Stardust Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Stardust Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Stardust Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Stardust White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Starfall Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Starfall Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Starfrost Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Stargaze Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Stargaze White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Starlight": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Starlight Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Starlight Black (Starry Black)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Starlight Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Starlight Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Starlight Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Starlight White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Starlight black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Starlit Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Starlit Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Starlite Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Starry": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Starry  Blue": {cssName: "darkblue", rgb: "rgb(0,0,139)"},
    "Starry Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Starry Blue": {cssName: "darkblue", rgb: "rgb(0,0,139)"},
    "Starry Blue (Starry Night)": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Starry Dream": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Starry Glow": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Starry Gold": {cssName: "olive", rgb: "rgb(128,128,0)"},
    "Starry Gray": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Starry Night": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Starry Night (512 GB only)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Starry Night Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Starry Night Blue": {cssName: "navy", rgb: "rgb(0,0,128)"},
    "Starry Oasis": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Starry Purple": {cssName: "indigo", rgb: "rgb(75,0,130)"},
    "Starry Rock Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Starry Silver": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Starry Sky": {cssName: "steelblue", rgb: "rgb(70,130,180)"},
    "Starry White": {cssName: "lightslategray", rgb: "rgb(119,136,153)"},
    "StarryР’В NightР’В Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Startrail Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Startrail Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Startrail Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Startrail Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Startrails Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Stary Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Stealth Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Steel": {cssName: "steelblue", rgb: "rgb(70,130,180)"},
    "Steel Black": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Steel Blue": {cssName: "royalblue", rgb: "rgb(65,105,225)"},
    "Steel Gray": {cssName: "slategray", rgb: "rgb(112,128,144)"},
    "Steel Grey": {cssName: "slategray", rgb: "rgb(112,128,144)"},
    "Stellar Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Stellar Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Stellar Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Stellar Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Stellar Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Stellar Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Stellar Pink": {cssName: "pink", rgb: "rgb(255,192,203)"},
    "Stellar Shadow": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Stone Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Stone gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Stonehold Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Storm Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Storm Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Storm Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Storm Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Storm Grey (Mystic Black)": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Storm White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Stormy Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Stream White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Streamer Secret": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Streaming Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Streaming Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Stripe Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Stripe Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Striped Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Stroked Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Stroked Cyan": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Stylish Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Submarine Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Submarine Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Succulent Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Suede Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Suede Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Summer Cyan": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Summer Lilac": {cssName: "plum", rgb: "rgb(221,160,221)"},
    "Summer Mojito": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Summer Sky Blue": {cssName: "royalblue", rgb: "rgb(65,105,225)"},
    "Sun Shower": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Sunbeam Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Sundarbans Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Sunfire Yellow": {cssName: "yellow", rgb: "rgb(255,255,0)"},
    "Sunglow Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Sunlight Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Sunlit Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Sunny Oasis": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Sunrise Beige": {cssName: "sandybrown", rgb: "rgb(244,164,96)"},
    "Sunrise Blue": {cssName: "rebeccapurple", rgb: "rgb(102,51,153)"},
    "Sunrise Copper": {cssName: "peru", rgb: "rgb(205,133,63)"},
    "Sunrise Flare": {cssName: "sandybrown", rgb: "rgb(244,164,96)"},
    "Sunrise Gold": {cssName: "goldenrod", rgb: "rgb(218,165,32)"},
    "Sunrise Gold (Glory Gold)": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Sunrise Orange": {cssName: "goldenrod", rgb: "rgb(218,165,32)"},
    "Sunrise Red": {cssName: "tomato", rgb: "rgb(255,99,71)"},
    "Sunrise Violet": {cssName: "palevioletred", rgb: "rgb(219,112,147)"},
    "Sunrise White": {cssName: "navajowhite", rgb: "rgb(255,222,173)"},
    "Sunrise Yellow": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Sunset Blue": {cssName: "rebeccapurple", rgb: "rgb(102,51,153)"},
    "Sunset Blush": {cssName: "tomato", rgb: "rgb(255,99,71)"},
    "Sunset Dazzle": {cssName: "tomato", rgb: "rgb(255,99,71)"},
    "Sunset Dune": {cssName: "tomato", rgb: "rgb(255,99,71)"},
    "Sunset Gold": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Sunset Golden": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Sunset Jazz": {cssName: "tomato", rgb: "rgb(255,99,71)"},
    "Sunset Melody": {cssName: "tomato", rgb: "rgb(255,99,71)"},
    "Sunset Orange": {cssName: "darkorange", rgb: "rgb(255,140,0)"},
    "Sunset Peach": {cssName: "lightsalmon", rgb: "rgb(255,160,122)"},
    "Sunset Pink": {cssName: "lightsalmon", rgb: "rgb(255,160,122)"},
    "Sunset Purple": {cssName: "indianred", rgb: "rgb(205,92,92)"},
    "Sunset Red": {cssName: "orangered", rgb: "rgb(255,69,0)"},
    "Sunset Sierra": {cssName: "tomato", rgb: "rgb(255,99,71)"},
    "Sunset Spice Pink": {cssName: "lightsalmon", rgb: "rgb(255,160,122)"},
    "Sunshine Coast (Sunshine Gold)": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Sunshine Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Sunshine Yellow": {cssName: "yellow", rgb: "rgb(255,255,0)"},
    "Super Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Supernova": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Supernova Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Supersonic Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Supersonic Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Supersonic Yellow": {cssName: "yellow", rgb: "rgb(255,255,0)"},
    "Surf": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Surf Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Surf the Web": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Surfing Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Surfing Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Swag Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Swan Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Swarovski edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Sword Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Symphony Cyan": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Tahiti Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Tahiti Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Tan": {cssName: "tan", rgb: "rgb(210,180,140)"},
    "Tangerine": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Tarnish": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Teal": {cssName: "teal", rgb: "rgb(0,128,128)"},
    "Teal Blue": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Tech Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Tech Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Tech Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Tempered Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Tempest Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Tempo Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Temporal Orbits": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Textured Titanium": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "That Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "That White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Thom Browne Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Thunder Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Thunder Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Thunder Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Tidal Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Timber Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Timeless Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Titan": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Titan Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Titan Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Titan Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Titan Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Titan Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Titanium": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Titanium Black": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Titanium Blue": {cssName: "slateblue", rgb: "rgb(106,90,205)"},
    "Titanium Chrome": {cssName: "darkgray", rgb: "rgb(169,169,169)"},
    "Titanium Gold": {cssName: "darkkhaki", rgb: "rgb(189,183,107)"},
    "Titanium Gold (Titanium Silver)": {cssName: "darkkhaki", rgb: "rgb(189,183,107)"},
    "Titanium Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Titanium Green": {cssName: "seagreen", rgb: "rgb(46,139,87)"},
    "Titanium Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Titanium Icyblue": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Titanium Jade Green": {cssName: "seagreen", rgb: "rgb(46,139,87)"},
    "Titanium Jet Black": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Titanium Jetblack": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Titanium Lux": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Titanium Matte": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Titanium Orange": {cssName: "peru", rgb: "rgb(205,133,63)"},
    "Titanium Pink Gold": {cssName: "burlywood", rgb: "rgb(222,184,135)"},
    "Titanium Purple": {cssName: "rebeccapurple", rgb: "rgb(102,51,153)"},
    "Titanium Sapphire": {cssName: "steelblue", rgb: "rgb(70,130,180)"},
    "Titanium Silver": {cssName: "darkgray", rgb: "rgb(169,169,169)"},
    "Titanium Silver Blue": {cssName: "slateblue", rgb: "rgb(106,90,205)"},
    "Titanium Violet": {cssName: "slateblue", rgb: "rgb(106,90,205)"},
    "Titanium White": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Titanium White Silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Titanium Yellow": {cssName: "darkkhaki", rgb: "rgb(189,183,107)"},
    "Titanium silver": {cssName: "darkgray", rgb: "rgb(169,169,169)"},
    "Topaz": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Topaz Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Tornado Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Tornado Green (Northern Green)": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Tranquil Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Tranquil Green (Forest Green)": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Tranquil Lake Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Tranquil Sea Blue": {cssName: "royalblue", rgb: "rgb(65,105,225)"},
    "TransSilver": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Transparent": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Transparent Dark Knight": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Transparent Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Transparent Silver Deuterium": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "Travertine Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Trend edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Trendy Emerald Green": {cssName: "forestgreen", rgb: "rgb(34,139,34)"},
    "Tropical Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Tropical Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Tropical Green (Dynamic Green)": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Truffle Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Truffle Black (Vinyl Black)": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Tundra Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Turbo Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Turbo Cyan": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Turbo Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Turbo Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Turbo Yellow": {cssName: "yellow", rgb: "rgb(255,255,0)"},
    "Turquoise": {cssName: "turquoise", rgb: "rgb(64,224,208)"},
    "Turquoise Cyan": {cssName: "turquoise", rgb: "rgb(64,224,208)"},
    "Turquoise Dream": {cssName: "turquoise", rgb: "rgb(64,224,208)"},
    "Turquoise Green": {cssName: "mediumseagreen", rgb: "rgb(60,179,113)"},
    "Tuscany Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Tuscany Brown": {cssName: "brown", rgb: "rgb(165,42,42)"},
    "Twilight": {cssName: "darkslateblue", rgb: "rgb(72,61,139)"},
    "Twilight Black": {cssName: "midnightblue", rgb: "rgb(25,25,112)"},
    "Twilight Blue": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "Twilight Gold": {cssName: "peru", rgb: "rgb(205,133,63)"},
    "Twilight Grey": {cssName: "dimgray", rgb: "rgb(105,105,105)"},
    "Twilight Orange": {cssName: "sienna", rgb: "rgb(160,82,45)"},
    "Twilight Purple": {cssName: "rebeccapurple", rgb: "rgb(102,51,153)"},
    "Twilight Violet": {cssName: "rebeccapurple", rgb: "rgb(102,51,153)"},
    "Twilight White": {cssName: "darkgray", rgb: "rgb(169,169,169)"},
    "Twilight purple": {cssName: "rebeccapurple", rgb: "rgb(102,51,153)"},
    "Twin Mint": {cssName: "palegreen", rgb: "rgb(152,251,152)"},
    "Twinkling Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Twisted Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Two Shades of Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Ultimate Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Ultra Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Ultra Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Ultramarine": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Ultramarine Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Ultramarine Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Ultraviolet Sunset": {cssName: "tomato", rgb: "rgb(255,99,71)"},
    "Umbra Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Unicorn White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Uranolite Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Uranolith Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Urban Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Urban Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Uyuni Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Uyuni Salt White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Vacation Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Vanilla Cream": {cssName: "lemonchiffon", rgb: "rgb(255,250,205)"},
    "Variable Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Various": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Vast sky": {cssName: "skyblue", rgb: "rgb(135,206,235)"},
    "Veil White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "Velocity Wave": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Velvet Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Velvet Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Velvet Grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Velvet Red (Coco Brown)": {cssName: "firebrick", rgb: "rgb(178,34,34)"},
    "Vengeance Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Vert Menthe": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Very Peri": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Vibing Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Vibrant Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Vibrant Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Vibrant Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Vibrant grey": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Victory Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Victory Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Vintage Bronze": {cssName: "peru", rgb: "rgb(205,133,63)"},
    "Vintage Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Vintage Red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "Violet": {cssName: "blueviolet", rgb: "rgb(138,43,226)"},
    "Violet Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Violet Garden": {cssName: "blueviolet", rgb: "rgb(138,43,226)"},
    "Viridian Glass": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Virtual Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Vitality Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Viva Magenta": {cssName: "fuchsia", rgb: "rgb(255,0,255)"},
    "Volcanic Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Volcanic Gray": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Volcanic Grey": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Volcano Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Volcano Grey shade": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Volcano Orange": {cssName: "orange", rgb: "rgb(255,165,0)"},
    "Voyage Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Voyager Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Warm Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Wasteland Shadow": {cssName: "darkslategray", rgb: "rgb(47,79,79)"},
    "Water Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Water Gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Waterfall Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Wave Aqua": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "Wave Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Wave Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Wave Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Waving Aqua": {cssName: "aqua", rgb: "rgb(0,255,255)"},
    "White": {cssName: "white", rgb: "rgb(255,255,255)"},
    "White (BMW M branding)": {cssName: "white", rgb: "rgb(255,255,255)"},
    "White Ceramic": {cssName: "white", rgb: "rgb(255,255,255)"},
    "White Feather": {cssName: "white", rgb: "rgb(255,255,255)"},
    "White Hailstone": {cssName: "white", rgb: "rgb(255,255,255)"},
    "White Knight": {cssName: "white", rgb: "rgb(255,255,255)"},
    "White Lily": {cssName: "white", rgb: "rgb(255,255,255)"},
    "White Milk": {cssName: "white", rgb: "rgb(255,255,255)"},
    "White Prism": {cssName: "thistle", rgb: "rgb(216,191,216)"},
    "White Titanium": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "White-gold": {cssName: "khaki", rgb: "rgb(240,230,140)"},
    "Wildcat Blue": {cssName: "blue", rgb: "rgb(0,0,255)"},
    "Wilderness Black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "Wilderness Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Winsor Violet": {cssName: "blueviolet", rgb: "rgb(138,43,226)"},
    "Winter Mist": {cssName: "powderblue", rgb: "rgb(176,224,230)"},
    "Winter White": {cssName: "lavender", rgb: "rgb(230,230,250)"},
    "Wintergreen": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Wisteria Purple": {cssName: "purple", rgb: "rgb(128,0,128)"},
    "Wood Grain": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Woodland Green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "Wooyoungmi Edition": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Y2K Gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Yellow": {cssName: "yellow", rgb: "rgb(255,255,0)"},
    "Yellow Green": {cssName: "yellowgreen", rgb: "rgb(154,205,50)"},
    "Yellow-gold": {cssName: "gold", rgb: "rgb(255,215,0)"},
    "Yellow; other colors": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "Zephyr": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "black": {cssName: "black", rgb: "rgb(0,0,0)"},
    "gray": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "midnight blue": {cssName: "mediumblue", rgb: "rgb(0,0,205)"},
    "other colors": {cssName: "gray", rgb: "rgb(128,128,128)"},
    "peach": {cssName: "peachpuff", rgb: "rgb(255,218,185)"},
    "red": {cssName: "red", rgb: "rgb(255,0,0)"},
    "rose gold": {cssName: "sandybrown", rgb: "rgb(244,164,96)"},
    "silver": {cssName: "silver", rgb: "rgb(192,192,192)"},
    "water green": {cssName: "green", rgb: "rgb(0,128,0)"},
    "white": {cssName: "white", rgb: "rgb(255,255,255)"},
};

/**
 * Fallback values when a marketing color name is not found.
 */
export const DEFAULT_COLOR_INFO: ColorInfo = {
    cssName: "gray",
    rgb: "rgb(128,128,128)"
};

/**
 * Utility to safely retrieve color information for a device.
 */
export const getDeviceColorInfo = (marketingName: string): ColorInfo => {
    return DEVICE_COLOR_MAP[marketingName] || {cssName:marketingName};
};